import { UserProfile } from 'fitbeat.gym-core';
import { HeartRateStep, IHeartRate } from 'fitbeat.models';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { ScrollView, StyleSheet, View } from 'react-native';
import { connect } from 'react-redux';
import {
  Button,
  ButtonTypes,
} from '../../components';
import Theme, { ThemeType } from '../../theme';
import { IAppStore } from '../reducer';
import {
  heartRateMonitorDisconnectedSelector,
  heartRateRecievedErrorSelector,
  isRemovingHeartRateIdentifierSelector,
  isSavingHeartRateIdentifierSelector,
  isScanningBeltSelector, latestConnectedAppHRSelector, liveHeartRateSelector, liveHeartRateSourceTypeSelector,
} from '../selectors/heartRateMonitorSelectors';
import { BluetoothServiceSingleton } from '../utils/BluetoothServiceSingleton';
import { BLUETOOTH_SCAN_TIMEOUT, IBluetoothService } from '../utils/IBluetoothService';
import HasHeartRateDevice from './HasHeartRateDevice';
import { HomeWorkoutResponsiveLayout } from './HomeWorkoutResponsiveLayout';
import { MonitorConnecting } from './MonitorConnecting';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  themeType: ThemeType;
  userProfile: UserProfile;
  heartRateScanAction: any;
  isScanningBelt: boolean;
  heartRateRecievedError: string | null;
  liveHeartRate: number | null;
  liveHeartRateSourceType: 'ConnectedApp' | 'Bluetooth' | null,
  latestConnectedAppHR: IHeartRate | null;
  isRemovingHeartRateIdentifier: boolean;
  isSavingHeartRateIdentifier: boolean;
  heartRateMonitorDisconnected: boolean;
  t: (key: string) => string;
  testBelt(beltNumber?: string): void;
  closeModal(): void;
  removeDevice(): void;
  showFaq(): void;
  disconnectHrMonitor(): void;
  removeHrDeviceForUser(): void;
  goToStep(step: HeartRateStep): void;
  userUpdateFunc(): any;
}

export class TestHeartRateDevice extends PureComponent<IProps, {}> {
  public componentDidMount = () => {
    const { testBelt, userProfile, liveHeartRate } = this.props;
    if (!liveHeartRate) {
      testBelt(userProfile.heartRateMonitors?.home);
    }
  }

  public render() {
    const { t, removeDevice, showFaq,
      isScanningBelt,
      liveHeartRate, liveHeartRateSourceType,
      isRemovingHeartRateIdentifier,
    } = this.props;

    if (liveHeartRate && liveHeartRateSourceType === 'Bluetooth' && !isScanningBelt && !isRemovingHeartRateIdentifier) {
      return <HasHeartRateDevice {...this.props} />;
    }
    return (
      <View style={styles.container}>
        <ScrollView contentContainerStyle={styles.contentContainerStyle}>
          <MonitorConnecting {...this.props} />
        </ScrollView>
        <View style={styles.footer}>
        <HomeWorkoutResponsiveLayout
            containerStyle={styles.responsiveLayoutContainer}
            colStyle={styles.colStyle}
            rowStyle={styles.rowStyle}>
            <Button
              title={t('cantFindYourDevice')}
              onPress={showFaq}
              fontColor={Theme.PRIMARY}
              buttonType={ButtonTypes.TRANSPARENT}
              containerStyle={styles.buttonContainer}
            />
            <Button
              title={t('removeDevice')}
              onPress={removeDevice}
              fontColor={Theme.PRIMARY}
              buttonType={isRemovingHeartRateIdentifier ? ButtonTypes.DISABLED : ButtonTypes.OUTLINE}
              containerStyle={styles.buttonContainer}
            />
        </HomeWorkoutResponsiveLayout>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  responsiveLayoutContainer: {
    flex: 0,
    justifyContent: 'space-between',
  },
  colStyle: {
    flexDirection: 'column-reverse',
    alignSelf: 'stretch',
  },
  rowStyle: {
    flexDirection: 'row',
    alignSelf: 'stretch',
  },
  buttonContainer: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  contentContainerStyle: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  bpmContainer: {
    paddingTop: defaultScale(34),
    paddingBottom: defaultScale(20),
  },
  bpmIconContainer: {
    paddingBottom: defaultScale(20),
    alignSelf: 'center',
    textAlign: 'center',
    flexDirection: 'row',
  },
  bpmText: {
    fontSize: 40,
    marginLeft: defaultScale(5),
    alignSelf: 'center',
  },
  footer: {
    justifyContent: 'flex-end',
  },
  connectedText: {
    ...Theme.textStyle.heading,
    alignSelf: 'center',
    marginBottom: defaultScale(10),
  },
  hrIdText: {
    alignSelf: 'center',
  },
  margin: {
    marginBottom: defaultScale(10),
  },
});

const mapStateToProps = (state: IAppStore) => ({
  isScanningBelt: isScanningBeltSelector(state),
  liveHeartRate: liveHeartRateSelector(state),
  liveHeartRateSourceType: liveHeartRateSourceTypeSelector(state),
  latestConnectedAppHR: latestConnectedAppHRSelector(state),
  heartRateRecievedError: heartRateRecievedErrorSelector(state),
  isRemovingHeartRateIdentifier: isRemovingHeartRateIdentifierSelector(state),
  isSavingHeartRateIdentifier: isSavingHeartRateIdentifierSelector(state),
  heartRateMonitorDisconnected: heartRateMonitorDisconnectedSelector(state),
});

const mapDispatchToProps = (dispatch: any, ownProps: IProps) => {
  return {
    testBelt: (beltNumber: string) => {
      dispatch(ownProps.heartRateScanAction(
        beltNumber,
        ownProps.userProfile,
        BluetoothServiceSingleton.getBluetoothService,
        BLUETOOTH_SCAN_TIMEOUT,
      ));
    },
  };
};

export default translate(['heartRateDevice'])(connect(mapStateToProps, mapDispatchToProps)(TestHeartRateDevice));
